const KEEP_UPPER = new Set(["PO", "HO", "GST", "TDS", "NEFT", "RTGS", "IMPS", "UPI", "LLP", "CCI", "EB", "MSEB", "BEST", "HP", "LPG", "ATM", "CK", "HUF", "PF", "ESIC"]);

// ALL CAPS / all lower → Title Case; mixed-case text is left untouched.
export const stdCase = (s) => {
  const t = String(s ?? "").trim();
  if (!t || !/[a-z]/i.test(t) || (t !== t.toUpperCase() && t !== t.toLowerCase())) return t;
  return t.replace(/[A-Za-z][A-Za-z']*/g, (w) =>
    KEEP_UPPER.has(w.toUpperCase()) ? w.toUpperCase() : w[0].toUpperCase() + w.slice(1).toLowerCase());
};
